import SegmentService from './segment.service';

export default angular.module('fp:customerportal:common:service', [])
    .service('segment', SegmentService);